import { types } from "../types/types";
const intitalState = {
    orders: [],
    orderDetails: {},
};

const ordersReducer = (state = intitalState, action) => {
    switch (action.type) {
        case types.ORDERS:
            return {
                ...state,
                orders: action.payload,
            };
        case types.ORDER_DETAILS:
            return {
                ...state,
                orderDetails: action.payload,
            };
        default:
            return { ...state };
    }
};

export default ordersReducer;
